import React, { useEffect, useState } from 'react';
import logo from '../../../assets/website/images/footer-logo-img.svg';
import twitter from '../../../assets/website/images/twitter.svg';
import insta from '../../../assets/website/images/insta.svg';
import facebook from '../../../assets/website/images/facebook.svg';
import youtube from '../../../assets/website/images/youtube.svg';
import { Link, useLocation } from 'react-router-dom';
import downloadBabeAppImage from '../../../assets/website/images/download-babe-app-img.png';
import googlePlayImage from '../../../assets/website/images/google-play-image.png';
import appStoreImage from '../../../assets/website/images/app-store-image.png';
import * as commonServices from '../services/website.services';
import { CMS_PAGES_POSITIONS } from '../../../utils/Constants';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { capitalizeFirstLetter } from '../../../utils/commonfunction';
import toHtml from 'html-react-parser';

const WebsiteFooter = () => {

  const [companyMenuData, setCompanyMenuData] = useState([]);
  const [impMenuData, setImpMenuData] = useState([]);
  const [getGlobalData, setGlobalData] = useState({});
  const myGlobalData = useSelector((state) => state.globalData);

  useEffect(() => {
    if (myGlobalData && myGlobalData?.data) {
      const settingsData = JSON.parse(myGlobalData?.data);
      setGlobalData(settingsData);
    }
  }, [myGlobalData]);

  useEffect(() => {
    commonServices.menuOptions({ menu_location: CMS_PAGES_POSITIONS.FOOTER }).then((response) => {
      let companyMenu = [];
      let linksMenu = [];
      response?.data?.forEach(element => {
        if (element.footer_menu_name === 'company') {
          companyMenu.push(element);
        } else {
          linksMenu.push(element);
        }
      });
      // setCompanyMenuData(companyMenu);
      setImpMenuData(linksMenu);
    }).catch((error) => {
      console.log("error", error);
    });
  }, []);


  return (
    <footer>
      <section className="babe-app ">
        <div className="container">
          <div className="container-box-2">
            <div className="row">
              <div className="col-md-6">
                <figure>
                  <img src={downloadBabeAppImage}
                    alt="download our App"
                  />
                </figure>
              </div>
              <div className="col-md-6">
                <div className="download-box">
                  <h2 className="h2-headline">Download the babe App</h2>
                  {/* <h5 className="h5-headline mb-3">
                    Everything you need, right at your fingertips
                  </h5> */}
                  <p className="body-1">
                    Whether you're scheduling a fertility injection, booking a
                    night nanny, or just need a moment to breathe—we’re here.
                    The babe app puts expert support in your pocket, 24/7.
                  </p>
                  <div className="store-image">
                    <a target={"_blank"} href={getGlobalData?.play_store_url}>
                      <img src={googlePlayImage} alt="google play icon" />
                    </a>
                    <a target={"_blank"} href={getGlobalData?.app_store_url}>
                      <img src={appStoreImage} alt="app store icon" />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div className="container footer-padding" id='get-app'>

        <div className="footer-top d-flex justify-content-between">
          <div className="footer-logo">
            <Link to="/">
              <img src={logo} alt='babe' />
            </Link>

          </div>
          <div className="footer-item">
            <h5 className="h5-headline">Important links</h5>
            <ul className="d-flex gap-3 flex-column">
              {/* <li className="subtitle-1"><a href="/">Our Story</a></li> */}
              <li className=" subtitle-1"><Link className="nav-link" to="/frequentlyAskedQuestions">Frequently Asked Questions</Link></li>
              {/* <li className=" subtitle-1"><Link className="nav-link" to="/meetTheFounder">Meet the Founders</Link></li> */}
              <li className=" subtitle-1"><Link to="/contact-us">Contact Us</Link></li>
            </ul>
          </div>
          
          <div className="footer-item">
            {getGlobalData?.social_media_details ?
              <>
                <h5 className="h5-headline">Connect with us</h5>
                <ul className="d-flex gap-3 social-link cp">
                  {getGlobalData?.social_media_details.map((item, index) => (
                    <li key={index}>
                      <a href={item?.link} target="_blank" rel="noreferrer">
                        {toHtml(item?.icon)}
                      </a>
                    </li>
                  ))
                  }
                </ul>
              </> : <></>
            }
          </div>

        </div>

        <div className="footer-bottom d-flex footer-item-padding justify-content-between">
          <div className="body-2 d-flex gap-10">
            {capitalizeFirstLetter(getGlobalData?.copy_right_text)}
          </div>
          <div className="d-flex gap-2">
            {impMenuData && impMenuData.length > 0 &&
              impMenuData.map((item, index) => (
                <Link key={index} to={`/org-info/${item?.slug}`} className="subtitle-2">
                  {capitalizeFirstLetter(item?.title)}
                </Link>
              ))
            }
          </div>
        </div>
      </div>
    </footer >
  )
}

export default WebsiteFooter;
